import { useQuery } from '@tanstack/react-query';
import { getBtc15TakeProfitHistory } from '../lib/apiClient';

// btc15-takeprofit-scheduled.ts checks for an early exit at most once a
// minute, so polling much faster than that wouldn't see anything new —
// but polling this rather than only syncing on visibility change (like
// useBtc15ModelHistory) keeps the card feeling live for a visitor actively
// watching the page, matching the main predictor's own live feel.
const POLL_INTERVAL_MS = 30_000;

/**
 * Server-authoritative read of "V1 + take-profit"'s track record — there is
 * no client-side write path here (see src/lib/btc15TakeProfitHistory.ts
 * for why an early exit can only ever be observed server-side).
 */
export function useBtc15TakeProfitHistory() {
  return useQuery({
    queryKey: ['btc15-takeprofit-history'],
    queryFn: getBtc15TakeProfitHistory,
    staleTime: POLL_INTERVAL_MS,
    refetchInterval: POLL_INTERVAL_MS,
  });
}
